module.exports = __webpack_public_path__ + "img/logo.19210d4c.png";